interface Dictionary {
  id: string
  name: string
}
export const mapToSelectOption = (dictionary: Dictionary[]) =>
  dictionary.map(({ id, name }) => ({ text: name, value: id }))
